import { render, staticRenderFns } from "./ButtonSignInGoogle.vue?vue&type=template&id=4bbd5874&scoped=true&"
import script from "./ButtonSignInGoogle.vue?vue&type=script&lang=js&"
export * from "./ButtonSignInGoogle.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSignInGoogle.vue?vue&type=style&index=0&id=4bbd5874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbd5874",
  null
  
)

export default component.exports